import { useState, useEffect } from "react";
import { Spinner } from "@aidkitorg/component-library";
import { usePost } from "../../../API";
import { useConnectionModal } from "./ConnectionModalContext";
import { SourceHeader } from "./SourceHeader";
import { type ConnectionModalState } from "./types";

const POLL_INTERVAL = 500;

interface ConnectionModalPendingPageProps {
  state: ConnectionModalState & { stage: "pending" };
}

export function ConnectionModalPendingPage({
  state,
}: ConnectionModalPendingPageProps) {
  const getConnectionStatus = usePost("/deck/get_connection_status");
  const { token, getLocalizedString, onConnectionSuccess, onUpdateState } = useConnectionModal();
  const [loadingText, setLoadingText] = useState(() => getLocalizedString("initialLoadingText", "loading_text"));

  useEffect(() => {
    const timer = setInterval(async () => {
      const status = await getConnectionStatus({ link_token: token });

      switch (status.status) {
        case "New":
          return setLoadingText(getLocalizedString("receivedCredentialsLoadingText", "loading_text"));
        case "Connecting":
          return setLoadingText(getLocalizedString("connectingLoadingText", "loading_text"));
        case "Connected":
          return onConnectionSuccess(state.connectionId);
        case "Error":
        case "InvalidCredentials":
        case "MfaQuestionInvalidAnswer":
        case "MfaQuestionNoAnswer":
          return onUpdateState({
            stage: "error",
            selectedSource: state.selectedSource,
            errorStatus: status.status,
          });
        case "MfaQuestion":
        case "SecurityQuestion":
          return onUpdateState({
            stage: "additional_question",
            selectedSource: state.selectedSource,
            connectionId: state.connectionId,
            question: status.question,
            answerExpected: status.answer_expected,
          });
        default:
          // Keep polling
          return;
      }
    }, POLL_INTERVAL);

    return () => clearInterval(timer);
  }, [state]);

  return <div>
    <SourceHeader source={state.selectedSource} />
    <Spinner />

    <span>{loadingText}</span>
  </div>;
}
